"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brow = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brow` : '') + (description ? ` desc-brow` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brow"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brow"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M19.974 13.6246L24 16.2214L19.974 18.8183H2.43816C1.0776 18.8183 0 17.6429 0 16.2214C0 14.8724 0.972909 13.735 2.28001 13.6303L2.43816 13.6246H19.974ZM3.214 15.001L2.46575 15.0015L2.36285 15.0051C1.82251 15.0486 1.37753 15.5688 1.37753 16.2214C1.37753 16.9076 1.86639 17.4408 2.43816 17.4408L3.214 17.44V15.001ZM16.989 15.001H4.591V17.44H16.989V15.001ZM19.5683 15.0018L18.367 15.001V17.44L19.5683 17.4401L21.4583 16.2214L19.5683 15.0018ZM2.87485 5V9.52001H12.672L12.7698 9.52174L12.9975 9.53574C13.0386 9.53928 13.0812 9.54343 13.1254 9.54818L13.409 9.58395C13.4594 9.59112 13.5113 9.59889 13.5648 9.60726L13.9041 9.66477L14.2802 9.73675L14.9131 9.87186L15.3807 9.98001L16.15 10.1693L16.708 10.3136L17.6121 10.557L18.5964 10.8328L19.6602 11.141L21.6179 11.7165L20.4095 10.0723C17.9445 6.71845 15.3685 5 12.672 5H2.87485ZM4.25199 8.1417V6.37753H12.672L12.8905 6.38246C14.4941 6.45468 16.1122 7.32205 17.7413 9.01735L17.9272 9.21525L17.269 9.03677L16.3066 8.78802L15.7191 8.6447L15.1748 8.51937L14.6734 8.41203L14.2147 8.32267C14.1418 8.30927 14.0707 8.29662 14.0013 8.28472L13.6064 8.22228L13.2537 8.17779C13.0879 8.16003 12.9379 8.14899 12.8035 8.14466L12.6835 8.14257L4.25199 8.1417Z",
    fill: "inherit"
  }));
};
var _default = exports.default = brow;